// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__HelveticaNeue_8e83cb', '__HelveticaNeue_Fallback_8e83cb'"},"className":"__className_8e83cb"};